export enum PassportType {
  NotSelected = 0,
  Passport = 1,
  IdentityCard = 2,
  InternationalPassport = 3,
  ResidencePermit = 4,
  IdCard = 8,
  TempResidencePermit = 11,
}
